import { useContext, useState } from "react"
import { useEffectOnce } from "react-use"

import { LocaleContext } from "../../components/Layout"
import { validatorTypes, validators } from "./forms"

export default function useInput({
  initialValue,
  errorsVisible,
  validatorType,
  required,
  type,
}) {
  const errorMessages = useContext(LocaleContext).ui.forms.errors
  const [value, setValue] = useState(initialValue)
  const [errorType, setErrorType] = useState()
  const [file, setFile] = useState()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffectOnce(() => setErrorType(validate(initialValue)))

  return {
    value,
    file,
    valid: !errorType,
    reset: () => setValue(initialValue),
    props: {
      errorMessage:
        errorsVisible && errorType ? errorMessages[errorType] : undefined,
      onChange: (event) => {
        const { value, checked } = event.target

        if (type === "file") {
          if (event.target.files) {
            setFile(event.target.files[0])
          }
        }

        if (type === "checkbox") {
          if (checked) {
            setValue(checked)
            setErrorType(validate(checked))
          } else {
            setValue(false)
            setErrorType(validate(false))
          }
        }

        if (type !== "checkbox") {
          setValue(value)
          setErrorType(validate(value))
        }
      },
    },
  }

  function validate(value) {
    if (required && !value) return validatorTypes.notBlank
    if (!isValid(value)) return validatorType
    return null
  }

  function isValid(value) {
    return validatorType ? validators[validatorType](value) : true
  }
}
